import {LangKeyType} from '../../../../../provider/locale/translation/type';
import {ProductGroupTypeEnum} from '../../../../../service/products/products-type';

export const createProductGroupHeaderMap: Record<ProductGroupTypeEnum, LangKeyType> = {
    [ProductGroupTypeEnum.File]: 'PRODUCTS__CREATE_GROUP__FILE__HEADER',
    [ProductGroupTypeEnum.Manual]: 'PRODUCTS__CREATE_GROUP__MANUAL__HEADER',
    [ProductGroupTypeEnum.Feed]: 'PRODUCTS__CREATE_GROUP__FEED__HEADER',
    [ProductGroupTypeEnum.Iiko]: 'PRODUCTS__CREATE_GROUP__IIKO__HEADER',
};
